/* eslint-disable no-unused-vars */
import type React from 'react';

// Aliases to all weights that the application
// loads for the Lato typeface:
const thin = 100;
const light = 300;
const regular = 400;
const semibold = 600;
const bold = 700;

const fontHeight = (fontSize: number, lineHeight: number | string, otherFontProps?: React.CSSProperties) => ({
  fontSize: `${fontSize}px`,
  fontWeight: regular,
  lineHeight: typeof lineHeight === 'number' ? lineHeight / fontSize : lineHeight,
  ...otherFontProps // please keep tidy and only use font-related props here
});

const basicTypeface = fontHeight(16, 19);
const smallTypeface = fontHeight(12, 15);

const typefaces = {
  basic: basicTypeface,
  small: smallTypeface,
  guideCard: {
    title: fontHeight(24, 29),
    smallTitle: fontHeight(16, 24),
    subtitle: fontHeight(14, 17)
  },
  guideDetails: {
    title: fontHeight(24, 29, {fontWeight: light}),
    slug: fontHeight(18, 22, {fontWeight: light}),
    summary: basicTypeface
  },
  instructionDetails: {
    title: fontHeight(24, 29, {fontWeight: light}),
    slug: {...basicTypeface, fontWeight: light}
  },
  modal: {
    title: {...basicTypeface, fontWeight: semibold}
  },
  newStepLink: {
    title: fontHeight(24, 29)
  },
  sidebar: {
    title: fontHeight(32, 39),
    subtitle: smallTypeface,
    item: basicTypeface,
    overviewLink: fontHeight(15, 18)
  },
  table: {
    bodyCell: fontHeight(14, '20px', {
      fontWeight: 'inherit'
    }),
    xHeaderCell: fontHeight(16, '222px', {
      fontWeight: 'inherit'
    }),
    yHeaderCell: fontHeight(8, '40px', {
      fontWeight: 'inherit',
      textTransform: 'uppercase'
    })
  },
  topicCard: {
    title: fontHeight(26, 31),
    slug: fontHeight(14, 17),
    message: fontHeight(18, 22)
  },
  translations: {
    title: fontHeight(24, 29)
  }
};

// design system text components
export const textStyles = {
  desktop: {
    heading2: {
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '36px'
    },
    heading3: {
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '28px'
    },
    generalSubheader: {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '22px'
    },
    generalBody: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      display: 'block'
    },
    generalCaption: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    link: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px'
    }
  }
};

export default typefaces;
